import { ExtStatsConnectQueryI } from "./stats-connect.query.ext";
import { ExtStatsConnectI } from "./stats-connect.result.ext";
import { StatsConnectI } from "./stats-connect.result.int";
import { StatsConnectQueryI } from "./stats-connect.query.int";
import { frontendRelease } from "src/main";
import { nullToEmptyString } from "src/app/shared/helpers/shared-zero-to-null.function";

export const MapStatsConnect = {
    mapQuery: (int: StatsConnectQueryI): ExtStatsConnectQueryI => {
        return {
            request: {
                app: nullToEmptyString(int.app),
                bundleVersion: nullToEmptyString(int.bundleVersion),
                customer: nullToEmptyString(int.customer),
                liveUpdate: nullToEmptyString(int.liveUpdate),
                liveUpdateChannel: nullToEmptyString(int.liveUpdateChannel),
                patch: nullToEmptyString(int.patch),
                platform: nullToEmptyString(int.platform),
                platformVersion: nullToEmptyString(int.platformVersion),
                randomDeviceId: nullToEmptyString(int.randomDeviceId),
                release: nullToEmptyString(int.release),
                username: nullToEmptyString(int.username),
                frontEndVersion: frontendRelease,
            }
        };
    },
    mapResult: (_ext: ExtStatsConnectI, _params): StatsConnectI => {
        return {

        };
    }
};
